import React, { FunctionComponent } from 'react';
import { IKpiMetricDetail, IKpiMetricsProps } from './types';
import { CircularAvatar } from '../../common/CustomAvatar';
import { userSelectors } from '../../../../app/resource/user/user.selectors';
import { useSelectWithParams } from '../../../../utils/selector.utils';

const KpisMetrics: FunctionComponent<IKpiMetricsProps> = ({ kpis, showUsers = false }) => {
  return (
    <div className="kpi-report-table panel my-1 p-2">
      <div className="aic flex theme-gradient-2 mb-2 panel px-2 py-1">
        <h2 className="white bold">KPI&apos;S</h2>
      </div>
      <div className="border-radius-1 lightGray-bg p-2 container">
        <div className="table-container kpi-settings-table w100" role="table" aria-label="KPIs settings">
          {kpis.length === 0 ? (
            <div className="f-2 text-center">This member has no scores assigned assigned in the current period</div>
          ) : (
            <>
              <div className="flex-table header panel mb-1 aic py-0" role="rowgroup">
                {showUsers && (
                  <div className="px-1" style={{ width: 200 }}>
                    USER
                  </div>
                )}
                <div className="px-1" style={{ width: 300 }}>
                  MEASURABLE
                </div>
                <div className="px-1" style={{ flex: 1 }}>
                  GOAL
                </div>
                <div className="kpi-metrics-overview">
                  <div className="blue text-center">SCORES</div>
                  <div className="purple text-center">AVERAGE</div>
                  <div className="orange text-center">HITS</div>
                </div>
              </div>
              <>
                {kpis.map((kpi, index) => (
                  <KpiMetricDetail kpi={kpi} key={index} userId={showUsers ? kpi.userId : undefined} />
                ))}
              </>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const KpiMetricDetail: FunctionComponent<IKpiMetricDetail> = ({ kpi, userId }) => {
  const user = useSelectWithParams(userSelectors.selectResourceById, userId ?? '');
  return (
    <div className="panel flex-table flex p-2 align-center w100" key={kpi.title}>
      {user && (
        <div className="px-1 flex align-center" style={{ width: 200 }}>
          <CircularAvatar
            src={user.image}
            title={`${user.firstName} ${user.lastName}`}
            classes="small-avatar mr-05"
            cursorPointer={false}
          />
          <div className="">
            <h3 className="">{`${user.firstName} ${user.lastName}`}</h3>
          </div>
        </div>
      )}
      <div className="px-1" style={{ width: 300 }}>
        {kpi.title}
      </div>
      <div className="px-1 flex align-center" style={{ flex: 1 }}>
        <span className="round-icon-small mr-1">{kpi.goal}</span>
        <div className="account-item-desc">
          <h3 className="account-item-title">
            {kpi.units === '$'
              ? `${kpi.units}${Number(kpi.score).toLocaleString()}`
              : `${Number(kpi.score).toLocaleString()} ${kpi.units}`}
          </h3>
        </div>
      </div>
      <div className="kpi-metrics-overview">
        <div className="p-1 bold blue lightBlue-bg border-radius-1 text-center">{kpi.total}</div>
        <div className="p-1 bold purple lightPurple-bg border-radius-1 text-center">
          {kpi.units === '$'
            ? `${kpi.units}${Number(Math.round(kpi.avg * 100) / 100).toLocaleString()}`
            : Number(Math.round(kpi.avg * 100) / 100).toLocaleString()}
        </div>
        <div className="p-1 bold orange lightYellow-bg border-radius-1 text-center">
          {Math.round((kpi.hits / kpi.total) * 100)} %
        </div>
      </div>
    </div>
  );
};
export default KpisMetrics;
